import React, { useContext } from "react"
import GameContext from "../../../Context/GameContext"
import styled from "styled-components"
import getMediaUrl from "../../../utils/mediaUrl"
import { Button } from "../styles"

const Wrap = styled.div`
  min-height: 200px;
  max-height: calc(100vh - 700px);
  display: flex;
  flex-direction: column;
  align-items: start;
  overflow-y: scroll;
`

const Round = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`

const RoundTitle = styled.div`
  font-weight: bold;
  font-size: 1.2em;
`

const Turn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`

const TurnTitle = styled.div`
  font-weight: bold;
`

const TurnQuestion = styled.div`
  font-size: 0.8em;
  text-align: left;
`

const TurnOptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
`

const Option = styled.div`
  width: 100%;
  font-size: 0.8em;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: ${props =>
    props.isInHistory ? "3px solid green" : "1px solid gray"};
  border-radius: 5px;
`

const OptionSummary = styled.div`
  display: flex;
  margin-left: 10px !important;
  text-align: left;
`

const Impact = styled.div`
  display: flex;
  margin: 0px !important;
  margin-left: auto !important;
`
const ImpactItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 5px;
  border-radius: 5px;
  column-gap: 5px;
  margin: 0px !important;
`
const ImpactImg = styled.img`
  width: 25px;
`

const Summary = styled.div`
  font-size: 0.8em;
  width: 100%;
  border-top: 1px solid black;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding-top: 10px;
`

const Player = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
  margin: 0px !important;
`

export const DownloadButton = styled(Button)`
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
`

export const GlobalOutroResults = props => {
  const { gameData, gameState, gameProps } = useContext(GameContext)
  const history = gameState?.history || []
  const rounds = gameData?.rounds || []
  const unit = gameData?.game_resource?.unit || ""
  const players = gameState.players
  const host = gameState.host
  // const downloadButtonLabel =
  //   gameData?.game_outro?.host_results_button || "Download"

  return (
    <Wrap id="print-area">
      {rounds.map((round, roundIndex) => {
        const turns = round?.turns || []
        return (
          <Round key={roundIndex}>
            <RoundTitle>{round?.round_name}</RoundTitle>
            {turns.map((turn, turnIndex) => {
              const options = turn?.turn_options || []
              const turnIsInHistory = history?.some(
                historyItem => historyItem?.turnId === turn?.id
              )
              if (!turnIsInHistory) return null
              return (
                <Turn key={turnIndex}>
                  <TurnTitle>{turn?.turn_title}</TurnTitle>
                  <TurnQuestion>
                    {turn?.turn_question?.guest_question}
                  </TurnQuestion>
                  <TurnOptions>
                    {options.map((option, optionIndex) => {
                      const impact = option?.impact || []
                      const optionIsInHistory = history?.some(
                        historyItem => historyItem?.optionId === option?.id
                      )
                      return (
                        <Option
                          key={optionIndex}
                          isInHistory={optionIsInHistory}
                        >
                          <OptionSummary>
                            {option?.guest_title}: {option?.guest_description}
                          </OptionSummary>
                          <Impact>
                            {impact.map((impactItem, index) => {
                              const impactNumber = impactItem?.impact
                              const impactOnImage = getMediaUrl(
                                gameProps?.strapiUrl,
                                impactItem?.co_op_role?.avatar?.url
                              )
                              return (
                                <ImpactItem key={index}>
                                  <ImpactImg src={impactOnImage} />
                                  <div>
                                    {impactNumber}
                                    {unit}
                                  </div>
                                </ImpactItem>
                              )
                            })}
                          </Impact>
                        </Option>
                      )
                    })}
                  </TurnOptions>
                </Turn>
              )
            })}
          </Round>
        )
      })}
      <Summary>
        {players.map((player, index) => {
          const playerImg = getMediaUrl(
            gameProps?.strapiUrl,
            player?.role?.avatar?.url
          )
          return (
            <Player key={index}>
              <div>- {player?.name}</div>
              <ImpactImg src={playerImg} />
              <div>
                {player?.energy.current}
                {unit}
              </div>
            </Player>
          )
        })}
        <Player>
          <div>- {host?.name}</div>
          <ImpactImg src={host?.role?.avatar?.url} />
          <div>
            {host?.energy.current}
            {unit}
          </div>
        </Player>
        {/* <DownloadButton onClick={() => window.print()} id="hide-print">
          {downloadButtonLabel}
        </DownloadButton> */}
      </Summary>
    </Wrap>
  )
}
